import React, { Suspense } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import Loader from "./components/Loader";
import ScrollToTop from "./components/ScrollToTop";
import Metaverse from "./pages/Metaverse";
import Gpt from "./pages/Gpt";
import MarketPlace from "./pages/MarketPlace";
import SimulationPage from "./pages/Simulation";
import PageNotFound from "./pages/PageNotFound.js";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermCondition from "./pages/TermCondition";
import LegalDisclaimer from "./pages/LegalDisclaimer";
import NewsUpdate from "./pages/NewsUpdate.js";
import RedirectSpinner from "./components/RedirectSpinner.js";
// import CommonService from "./services/CommonService.js";
import { useAuth } from "./context/userContext.js";
import Sitemap from "./pages/sitemap.js";
import EducationTool from "./pages/EducationTool.js";

// Lazy-loaded pages
const Home = React.lazy(() => import("./pages/Home"));
const About = React.lazy(() => import("./pages/About"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Login = React.lazy(() => import("./pages/Login"));
const ForgetPassword = React.lazy(() => import("./pages/ForgetPassword"));
const Profile = React.lazy(() => import("./pages/Profile"));
const Careers = React.lazy(() => import("./pages/Careers"));
const BecomePartner = React.lazy(() => import("./pages/BecomePartner"));
const Investment = React.lazy(() => import("./pages/Investment.js"));
const EditBlog = React.lazy(() => import("./pages/userPages/EditBlog.js"));
const CreateBlog = React.lazy(() => import("./pages/userPages/CreateBlog.js"));

const ChatBot = React.lazy(() => import("./pages/ChatBot.js"));
const BlogDetail = React.lazy(() => import("./pages/BlogDetail.js"));

const App = () => {
  const { auth } = useAuth();

  return (
    <>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/metaverse" element={<Metaverse />} />
            <Route path="/gpt" element={<Gpt />} />
            {/*  */}
            <Route path="/education-tools" element={<EducationTool />} />

            <Route path="/market-place" element={<MarketPlace />} />
            <Route path="/simulation" element={<SimulationPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/term-and-condition" element={<TermCondition />} />
            <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgetPassword />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/become-our-partner" element={<BecomePartner />} />
            <Route path="/news-update" element={<NewsUpdate />} />
            <Route path="/web-sitemap" element={<Sitemap />} />
            <Route path="/chat-with-lyra" element={<ChatBot />} />
            <Route path="/investment" element={<Investment />} />
            <Route path="/blog-detail" element={<BlogDetail />} />
            <Route
              path="/"
              element={auth?.user?._id ? <Outlet /> : <RedirectSpinner />}
            >
              <Route path="profile" element={<Profile />} />
              <Route exact path="create-blog" element={<CreateBlog />} />
              <Route exact path="edit-blog" element={<EditBlog />} />
            </Route>

            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
};

export default App;
